// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Card from './Card/Card';
import Request from '../../../api/Request';
import { observable } from 'mobx';
import CommentSection from './CommentSection/CommentSection';
import { Redirect } from 'react-router';
import Subscriber from '../../../api/Subscriber';
import CurrentMatches from './CurrentMatches/CurrentMatches';

@inject('userStore', 'componentStore')
@observer class Container extends Component<any, any> {

	@observable question: any;

	@observable failed: boolean = false;

	@observable receivedComments: any = {};

	subscriber = new Subscriber();

	constructor(props: any) {
		super(props);

		this.handleUpdateSubscriberMessage = this.handleUpdateSubscriberMessage.bind(this);

	}

	componentDidMount() {
		Request.get('/questions/' + this.props.id, {}).then((response) => {
			if(!response.status) {
				this.question = response;
				this.subscriber.addTopic(
					'/questions/' + this.question.id, 
					'question_update_' + this.question.id, 
					this.handleUpdateSubscriberMessage
				);

				this.subscriber.subscribe();
			} else {
				this.failed = true;
			}
		});
	}

	componentWillUnmount() {
		this.subscriber.unsubscribe();
	}

	handleUpdateSubscriberMessage(response: any) {
		const question = response['@question'];
		if (response['@comment']) {
			const comment = response['@comment'];
			if(response['@action'] === 'post') {
				this.receivedComments[this.getIndexFromOptionId(comment.question_option.id, question)] = comment;
			} else if(response['@action'] === 'delete') {
				this.receivedComments[this.getIndexFromOptionId(response['@removedOption'], question)] = { action: 'refetch' };
			}
		}
		if (question.question_options[0].votes === this.question.question_options[0].votes && this.question.question_options[1].votes === question.question_options[1].votes) {
			return false;
		}
		this.question = response['@question'];
		Request.get('/questions/' + this.question.id + '/votes?limit=1&user=' + this.props.userStore.user.id, {}).then((response) => {
			if (!response.status && response.length > 0) {
				this.props.componentStore.chosenOptionId = response[0].question_option.id;
			}else {
				this.props.componentStore.chosenOptionId = undefined;
			}
		})
		
	} 

	getIndexFromOptionId(id: number, question: any): number {
		for(let option in question.question_options) {
			if(question.question_options[option].id === id) {
				return parseInt(option);
			}
		}

		return -1;
	}

	center() {
		const element = document.querySelector('.question');
		const commentSection = document.querySelector('.comment-section');
		if(element && commentSection) {
			// 135 = headerHeight(60) + marginCommentSectionTop(50) + marginCommentBottom(25)
			const toScroll = ((commentSection.clientHeight + 135) + element.clientHeight/2) - (window.innerHeight / 2);
			window.scrollTo(0, toScroll);
		}
	}

	render() {
		if(!this.failed) {
			return (
				<div className="question-container">
					{this.question ? 
						<CommentSection 
							center={this.center} 
							receivedComment={this.receivedComments[0] ? this.receivedComments[0] : null} 
							question={this.question} 
							order={0}/>
						:
						null
					}
					<Card question={this.question}/>
					{this.question ? 
						<CommentSection 
							center={this.center} 
							receivedComment={this.receivedComments[1] ? this.receivedComments[1] : null} 
							question={this.question} 
							order={1}/>
						:
						null
					}
					<CurrentMatches question={this.question} />
				</div>
			)
		} else {
			return (
				<Redirect to="/" />
			)
		}

	}
}

export default Container;

